import { useReducer } from 'react'

import ViewState, {
  viewStateReducer,
  VIEW_INITIAL_STATE,
  ViewAction,
} from 'tripPlanner/contexts/View/ViewState'

export default function useViewState(
  initialState: ViewState = VIEW_INITIAL_STATE,
) {
  const [state, dispatch] = useReducer<ViewState, [ViewAction]>(viewStateReducer, initialState)
  return { state, dispatch }
}
